// Initial state
const initialState = {};

// Reducer
export default (state = initialState, action = {}) => state;
